import TimelineCalendarView from './timeline-calendar.view';

const TimelineCalendar = TimelineCalendarView;

export default TimelineCalendar;
